export default __webpack_public_path__ + "static/media/Werfen_Docs_Employees_Manual_Rev01.6ff39823.pdf";